/** Trail's mark (a barcode climbing like a trail, last bar green = read) with an optional screen title. */
export function Brand({ title }: { title?: string }) {
  return (
    <header className="brand">
      <img src="/mark.svg" alt="" width={32} height={32} />
      <span className="brand-name">trail</span>
      {title && <span className="brand-title">{title}</span>}
    </header>
  );
}
